<div class="heading">
    Select the brands you provide services for
</div>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="card mb-6">
        <div class="mb-5">
            <input type="text" class="p-inputtext p-component" placeholder="Search brands..." [(ngModel)]="searchQuery"
                [ngModelOptions]="{ standalone: true }" (input)="onSearchChange()" />
        </div>

        <label *ngFor="let maker of filteredMakers" class="field-checkbox mt-3 cards cursor-pointer"
            [for]="'brand-' + maker.vehicleMakerId">
            <p-checkbox [inputId]="'brand-' + maker.vehicleMakerId" [label]="maker.name" [binary]="true"
                [value]="maker.vehicleMakerId" [formControl]="checkboxControls[maker.vehicleMakerId]"
                (onChange)="onCheckboxChange(maker.vehicleMakerId, $event.checked)"></p-checkbox>
        </label>

        <!-- Show this if no brands match the search -->
        <div *ngIf="searchQuery && filteredMakers.length === 0" class="p-error mt-2">
            Sorry, "{{ searchQuery }}" is not available in our brand list.
        </div>

        <!-- Validation error on submit -->
        <div *ngIf="showError" class="p-error">
            Please select at least one brand
        </div>
    </div>

    <button type="submit" pButton label="Next" class="btn btn-primary"></button>
</form>